import React from "react";
import svg from "../../../images/HeaderSvg.svg";
import { BsApple } from "react-icons/bs";
import playstore from "../../../images/playstore.png";

const Banner = () => {
  return (
    <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-10 p-10">
      <div className=" space-y-16 p-10">
        <div className="space-y-6">
          <h2 className="lg:text-5xl md:text-4xl text-3xl font-bold">
            Digital identity <span className="text-[#06E073]">Simplified</span>
          </h2>

          <p className="text-accent lg:text-[20px] md:text-lg text-sm">
            The most secure password wallet for all your applications.{<br />}
            <span className="text-[#06E073]">Get Started Now</span>
          </p>
        </div>
        <div className="flex flex-wrap gap-5  ">
          <div className="flex gap-1 bg-black border-2 border-gray-400 px-4 py-2 text-white rounded-xl items-center">
            <BsApple className="text-[40px]" />
            <div>
              <p>Download on the</p>
              <h3 className="lg:text-2xl text-xl font-bold">App Store</h3>
            </div>
          </div>
          <div className="flex gap-1 bg-black border-2 border-gray-400 px-4 py-2 text-white rounded-xl items-center">
            <img src={playstore} alt="" className="w-12" />
            <div>
              <p>GET IT ON</p>
              <h3 className="lg:text-2xl text-xl font-bold">Google Play </h3>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img src={svg} alt="" />
      </div>
    </div>
  );
};

export default Banner;
